import { Outlet, ScrollRestoration } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Header from "../Header";
import Footer from "../Footer";

const SiteLayout = () => {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <ScrollRestoration />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Toaster />
      <Footer />
    </div>
  );
};

export default SiteLayout;
